import React, {useEffect, useState} from 'react';
import './styles.scss';
import DHMSTimer from './DHMSTimer';
import CalendarDownload from './CalendarDownload';

const CountdownCalendar: React.FC<any> = ({
  countdown_title,
  countdown_bgcolor,
  countdown_title_color,
  countdown_title_font_size,
  countdown_show_timer,
  countdown_datetime,
  countdown_datetime_utc,
  countdown_datetime_countdown,
  countdown_timer_color,
  countdown_timer_font_size,
  countdown_timer_bgcolor,
  countdown_show_calendar,
  countdown_timer_label_font_size,
  countdown_timer_separator_color,
  countdown_calendar_title,
  countdown_calendar_title_font_size,
  countdown_calendar_title_color,
  countdown_calendar_bgcolor,
  countdown_calendar_options,
  countdown_nid,
  countdown_id_page_class,
  wrapper_top_spacing,
  wrapper_bottom_spacing,
  countdown_top_spacing,
  countdown_bottom_spacing,
  component_tracking_id,
}) => {

  // Test hardcode data.
  // Uncomment const startDate = "2024-11-29T17:30:00Z";
  // Use https://time.lol/ to see this string formatted.
  const startDate = countdown_datetime_countdown;
  const [showDays, setShowDays] = useState(true);
  const [showHours, setShowHours] = useState(true);
  const [showMinutes, setShowMinutes] = useState(true);
  const [showSeconds, setShowSeconds] = useState(true);

  useEffect(() => {
    // Ex. to show/hide value of timer.
    setShowDays(true);
    setShowHours(true);
    setShowMinutes(true);
    setShowSeconds(true);
  }, [showDays, showHours, showMinutes, showSeconds]);

  return (
    <>
      {countdown_top_spacing ?
        <style
          dangerouslySetInnerHTML={{
            __html: `
            #` + countdown_id_page_class + `.countdown-calendar-container {
              padding-top: ` + countdown_top_spacing + ` !important;
            }
            `,
          }}
        />
        : null
      }
      {countdown_bottom_spacing ?
        <style
          dangerouslySetInnerHTML={{
            __html: `
            #` + countdown_id_page_class + `.countdown-calendar-container {
              padding-bottom: ` + countdown_bottom_spacing + ` !important;
            }
            `,
          }}
        />
        : null
      }
      {
        <style
          dangerouslySetInnerHTML={{
            __html: `
            #` + countdown_id_page_class + `.countdown-calendar-container {
              background-color: ` + countdown_bgcolor + `;
              color: #fff;
              padding: 0;
              display: block;
            }
            #` + countdown_id_page_class + ` {
              .countdownMainContainer {
                background-color: ` + countdown_bgcolor + `;
              }
              .countdownTitle {
                 color:  ` + countdown_title_color + `;
                 font-size: ` + countdown_title_font_size + `px;
              }
            }
         `,
          }}
        />
      }
      <>
        {countdown_show_timer ?
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + ` {
            .digit{
              background-color: ` + countdown_timer_bgcolor + `;
              color:` + countdown_timer_color + `;
            }

            .countDiv:before,
            .countDiv:after{
             position:absolute;
             background-color: ` + countdown_timer_separator_color + `;
            }

            .digit.static {
              background-color:  ` + countdown_timer_bgcolor + `;
            }

            .countdownItem {
              font-size: ` + countdown_timer_font_size + `px;
            }

            .countDaysLabel,
            .countHoursLabel,
            .countMinutesLabel,
            .countSecondsLabel {
              font-size:` + countdown_timer_label_font_size + `px;
              color: ` + countdown_timer_bgcolor + `;
            }
            /* Custom class to hide element */
            .hidden {
              display:none;
            }
          }
         `,
            }}
          />
          : null
        }
      </>
      <>
        {countdown_show_calendar ?
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + ` {
            .countdownCalendarContainer .calendarSelect {
              background-color: ` + countdown_calendar_bgcolor + `;
              font-size:` + countdown_calendar_title_font_size + `px;
              color: ` + countdown_calendar_title_color + `;
            }

            .countdownCalendarContainer .calendarSelect:focus {
              background-color: ` + countdown_calendar_bgcolor + `!important;
              box-shadow: 0 0 0 0.2rem ` + countdown_calendar_bgcolor + `!important;
              border-color:` + countdown_calendar_bgcolor + ` !important;
              color: ` + countdown_calendar_title_color + ` !important;
            }
            .calendarOptionItems.dropdown-menu .dropdown-item:hover {
              background-color: ` + countdown_calendar_bgcolor + `!important;
              color: ` + countdown_calendar_title_color + `;
             }
          }
 `,
            }}
          />
          : null
        }
      </>
      <>
        {showDays ? null :
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + ` {
            #countdownMockup .countdownItemContainerDays {
              display: none !important;
            }
          }
          `,
            }}
          />
        }
      </>
      <>
        {showHours ? null :
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + ` {
            #countdownMockup .countdownItemContainerHours {
              display: none !important;
            }
          }
         `,
            }}
          />
        }
      </>
      <>
        {showMinutes ? null :
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + ` {
            #countdownMockup .countdownItemContainerMinutes {
              display: none !important;
            }
          }
           `,
            }}
          />
        }
      </>
      <>
        {showSeconds ? null :
          <style
            dangerouslySetInnerHTML={{
              __html: `
        #` + countdown_id_page_class + ` {
          #countdownMockup .countdownItemContainerSeconds {
            display: none !important;
          }
        }
         `,
            }}
          />
        }
      </>
      <>
        {wrapper_top_spacing ?
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + `-wrapper {
            padding-top: ` + wrapper_top_spacing + ` !important;
          }
          `,
            }}
          />
          : null
        }
        {wrapper_bottom_spacing ?
          <style
            dangerouslySetInnerHTML={{
              __html: `
          #` + countdown_id_page_class + `-wrapper {
            padding-bottom: ` + wrapper_bottom_spacing + ` !important;
          }
          `,
            }}
          />
          : null
        }
      </>
      <div id={`${countdown_id_page_class}-wrapper`} component-track-id={component_tracking_id} tracking-type="other" className="countdown-calendar-container-wrapper">
        <div id={countdown_id_page_class} className="countdown-calendar-container">
          <div className="countdownMainContainer">
            <div className="container-fluid">
              <div className="row">
                <>
                {countdown_title ?
                  <div
                    className="countdownTitleContainer countdownElementContainer">
                    <span className="countdownTitle">
                     {countdown_title}
                    </span>
                  </div>
                  : null
                }
                </>
                <>
                  {countdown_show_timer ?
                    <div
                      className="countdownTimerContainer countdownElementContainer">

                      <DHMSTimer
                        startDate={startDate}
                        onTimerFinished={() => {
                          (document.querySelector(
                            `#${countdown_id_page_class}-wrapper .countdownHolderElements.countdownHolder`
                          ) as HTMLInputElement).classList.add("hidden");
                        }}
                      />
                    </div>
                    : null
                  }
                </>
                <>
                  {countdown_show_calendar ?
                    <div
                      className="countdownCalendarContainer countdownElementContainer">
                      <CalendarDownload
                        calendarTitle={countdown_calendar_title}
                        calendarOptions={countdown_calendar_options}
                        calendarTrackingId={component_tracking_id}
                      />
                    </div>
                    : null
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CountdownCalendar;
